import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type DialogProps } from 'base-ui'

import { ProductPageOdsShellDialog } from '../ProductPageOdsDialog/ProductPageOdsShellDialog'

import { ProductPageOdsDialogContent } from './ProductPageOdsDialogContent'

type ProductPageOdsDialogProps = Pick<DialogProps, 'onClose' | 'open'>

export const ProductPageOdsDialogCh: FC<ProductPageOdsDialogProps> = ({
  onClose,
  open,
}) => (
  <ProductPageOdsShellDialog
    onClose={onClose}
    open={open}
    title={<FormattedMessage id="pdp.buyboxwithvariants.odsModal.title" />}
  >
    <ProductPageOdsDialogContent />
  </ProductPageOdsShellDialog>
)
